import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { siteName } from "@/mocks/mangaData";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex flex-col items-center justify-center min-h-screen text-center px-4 bg-background-50">
      <span className="absolute text-[8rem] md:text-[12rem] font-black text-background-200 select-none pointer-events-none z-0">
        404
      </span>
      <div className="relative z-10">
        <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
          页面未找到
        </h1>
        <p className="mt-3 text-sm text-foreground-500 font-mono">{location.pathname}</p>
        <p className="mt-5 max-w-md mx-auto text-sm md:text-base text-foreground-700 leading-7">
          你访问的路径在 {siteName} 中暂不存在。可能是链接已变更，或页面内容还在补全中。
        </p>
        <Link
          to="/"
          className="mt-7 inline-flex items-center gap-1.5 rounded-full bg-primary-500 text-background-50 px-6 py-3 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
        >
          <i className="ri-arrow-left-line text-base leading-none"></i>
          返回首页
        </Link>
      </div>
    </div>
  );
}